module.exports = __webpack_public_path__ + "static/media/list.0dd9e72f.svg";